// extracted by mini-css-extract-plugin
export var addToCartButton = "_qk-b";
export var arrowButtonContainer = "_qk-9";
export var arrowButtonIcon = "_qk-a";
export var carouselArrowButton = "_qk-6";
export var carouselElementContainer = "_qk-1";
export var left = "_qk-7";
export var productDisplayCarouselContainer = "_qk-0";
export var productTileContainer = "_qk-2";
export var productTileImage = "_qk-4";
export var productTileImageContainer = "_qk-3";
export var productTileTitle = "_qk-5";
export var right = "_qk-8";
export var sliderOverflow = "_qk-c";